import {
  Breadcrumb,
  Button,
  Input,
  Modal,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import "../../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import AddSectorModel from "./AddSectorModel";
import BulkSectorUpload from "./BulkSectorUpload";

const SectorList = () => {
  const { t } = useTranslation();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sectorList, setSectorList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [sectorId, setSectorId] = useState(null);
  const [newSectorAdded, setNewSectorAdded] = useState(false);
  const [modalKey, setModalKey] = useState(false);
    const [searchText, setSearchText] = useState("");
  

  // state iniatialisation
  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  // Fetch the Section List API
  useEffect(() => {
    const getSectorList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("sectorname/", state);
        if (apiResponse.data.results.success) {
          setSectorList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_sector_name"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getSectorList();
  }, [state, newSectorAdded, reload, t]);

  // Function to handle changes in table pagination, filters, and sorting
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  // Function of Shorting enum Value
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "sector_name" && sortOrder === "ascend") {
      sortingEnumKey = "sector_name";
    }
    if (sortField === "sector_name" && sortOrder === "descend") {
      sortingEnumKey = "-sector_name";
    }
    if (sortField === "id" && sortOrder === "ascend") {
      sortingEnumKey = "id";
    }
    if (sortField === "id" && sortOrder === "descend") {
      sortingEnumKey = "-id";
    }

    return sortingEnumKey;
  };

  // Function to Search Call Back
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  // function for Search any Value
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
          (key) => !changeRows.find((row) => row.id === key)
        );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const columns = [
    {
      title: "Sector ID",
      dataIndex: "id",
      key: "id",
      sorter: true,
    },
    {
      title: "Sector Name",
      dataIndex: "sector_name",
      key: "sector_name",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          <Tooltip
            color={colors}
            placement="left"
            title={
              <span style={{ color: "#fff" }}>
                Edit
              </span>
            }
          >
            <Editicon onClick={() => handleEdit(record.id)} style={{ cursor: "pointer" }} />
          </Tooltip>
          <Tooltip
            color={colors}
            placement="right"
            title={
              <span style={{ color: "#fff" }}>
                Archive
              </span>
            }
          >
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <Archive style={{ cursor: "pointer" }} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  // function on Edit the List
  const handleEdit = (id) => {
    setModalKey((prevKey) => !prevKey);
    setSectorId(id);
    showModal();
  };

  // function for Add the List
  const handleAdd = () => {
    setSectorId(null);
    showModal();
    setReload((reload) => !reload);
  };

  // unction For Archive the List
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("sectorname-delete/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids?.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("sector_archive_successfully1"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
        ErrorNotificationMsg(t("error_in_archive_sector_name"));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);
  const showBulkUpload = () => {
    setIsModalOpenBulk(true);
  };
  const handleOkBulk = () => {
    setIsModalOpenBulk(false);
  };
  const handleCancelBulk = () => {
    setIsModalOpenBulk(false);
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">

            <h3>{t("sector")}</h3>


            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("sector")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
              <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>

              </Space>
            </div>
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Create a new sector for organizing and managing specific areas or divisions within your project or organization.
                </span>
              }
            >
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={handleAdd}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("pl_add_sector")}
              </Button>
            </Tooltip>
            <Modal
              className="ModelPopupSec"
              title={sectorId ? t("Edit Sector") : t("Add Sector")}
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              closable={false}
              wrapClassName="modal-wrapper"
              keyboard={false}
            >
              <AddSectorModel
                handleCancel={handleCancel}
                setReload={setReload}
                sectorId={sectorId}
                modalKey={modalKey}
                setStateM={setState}
              />
            </Modal>

            <Modal
              className="ModelPopupSec"
              title="Upload File"
              open={isModalOpenBulk}
              onOk={handleOkBulk}
              onCancel={handleCancelBulk}
              closable={false}
              wrapClassName="modal-wrapper"
            >
              <BulkSectorUpload
                setNewSectorAdded={setNewSectorAdded}
                newSectorAdded={newSectorAdded}
                sectorId={sectorId}
                handleCancelBulk={handleCancelBulk}
              />
            </Modal>

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Archive"
                />
              </Popconfirm>
            )}

            <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/sector/archive">
                <Archiveicon />
              </Link>
            </Tooltip>
            <Tooltip placement="topLeft" title="Bulk Upload">
              <Link className="BulkFileUplodIcon" onClick={showBulkUpload}>
              </Link>
            </Tooltip>
          </Space>
        </div>
      </div>
      <section className="grid-sec tablegridsec">
        <div className="PR-body">
           <div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={sectorList}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
</div>
        </div>
      </section>
    </>
  );
};
export default SectorList;
